import { Button, Flex, Input, TextContent } from 'components';
import { useEffect, useState } from 'react';
import * as bi from 'react-bootstrap-icons';

interface IProps {
  email: string;
  sendedAt: Date;
  onCodeConfirmClick: (code: string) => void;
  onBackClick: () => void;
  onResendClick: () => void;
}

function FrameEmailCode(props: IProps) {
  const [code, setCode] = useState<string>('');
  const [secondsToResend, setSecondsToResend] = useState<number>(90);

  useEffect(() => {
    const timestampWhenAllowed = Math.floor(props.sendedAt.getTime() / 1000) + 90;

    const timer = setInterval(() => {
      const currentSeconds = Math.floor(Date.now() / 1000);
      const secondsToAllow = timestampWhenAllowed - currentSeconds;

      if (secondsToAllow >= 0) {
        setSecondsToResend(secondsToAllow);
      } else {
        clearInterval(timer);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [props.sendedAt]);

  const isValidCode = code.trim().length === 4;

  const handleResendClick = () => {
    if (secondsToResend <= 0) {
      props.onResendClick();
    }
  };

  const handleConfirmClick = () => {
    if (isValidCode) {
      props.onCodeConfirmClick(code.trim());
    }
  };

  const handleCodeEnterKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (isValidCode && e.code === 'Enter') {
      props.onCodeConfirmClick(code.trim());
    }
  };

  const handleBackClick = () => props.onBackClick();

  return (
    <Flex
      direction='column'
      gap={20}
    >
      <TextContent align='center'>Код авторизации был отправлен на E-Mail</TextContent>
      <TextContent align='center'>
        <b>{props.email}</b>
      </TextContent>
      <Input
        type='text'
        label='Код авторизации'
        placeholder='1234'
        icon={<bi.Alphabet />}
        value={code}
        onChange={setCode}
        onKeyDown={handleCodeEnterKeyDown}
      />
      <Flex
        direction='column'
        gap={5}
      >
        <Button
          color='red'
          disabled={!isValidCode}
          onClick={handleConfirmClick}
        >
          Подтвердить
        </Button>
        <Button
          color='transparent-red'
          size='small'
          disabled={secondsToResend > 0}
          onClick={handleResendClick}
        >
          Отправить ещё раз {secondsToResend > 0 && <span>({secondsToResend} сек)</span>}
        </Button>
        <Button
          color='transparent-red'
          size='small'
          onClick={handleBackClick}
        >
          Назад
        </Button>
      </Flex>
    </Flex>
  );
}

export default FrameEmailCode;
